import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import avatarImg from 'assets/images/avatar.svg';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styles from './styles.module.scss';
import { Menu, Dropdown, Drawer } from 'antd';
import { useQuery, useQueryClient } from 'react-query';
import logo from 'assets/images/logo.svg';
import turnDown from 'assets/images/turnDown.svg';
import iconJapan from 'assets/images/japan.png';
import flagEnglish from 'assets/images/flagEnglish.svg';
import iconUsd from 'assets/images/iconUsd.svg';
import logoForeign from 'assets/images/logoForeign.svg';
import { useTranslation } from 'react-i18next';
import { LANGUAGE, CustomerAccountType, ACTIVE, KEY_MENU, CustomerLocationType } from 'common';
import avatarDefault from 'assets/images/account.png';
import { IsTourOpenContext } from 'components/WrapperContext/IsTourOpenProvider';
import { IsMobileContext } from 'components/WrapperContext/IsMobileProvider';
import configs from 'config';
import Hamburger from 'hamburger-react';
import ModalAlert from 'components/Modal/ModalAlert';
import useVisibleModalWarrning from 'hook/useVisibleModalWarrning';
import { getFullNameByLocation } from 'utils';
import { cancelSubscription } from 'api/authentication';
import { handleErrorMessage } from 'helper';

export default function PageHeader() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { data: profile } = queryClient?.getQueryData('profile') as any;
  const { t, i18n } = useTranslation();
  const { isMobile, isOpenMenuMobile, setIsOpenMenuMobile } = useContext(IsMobileContext);
  const { setIsTourOpen } = useContext(IsTourOpenContext);
  const { visibleModalAlertWarring, setVisibleModalAlertWarrning, url, setUrl } = useVisibleModalWarrning() as any;
  const location = useLocation();
  const [keyMenu, setKeyMenu] = useState(0);
  const checkCreatedOrder = location.pathname.startsWith('/order/created');
  const handleLogout = () => {
    Cookies.remove('token');
    Cookies.remove('refreshToken');
    history.push('/login');
    window.location.reload();
  };
  const changeLanguage = (lng: any) => {
    i18n.changeLanguage(lng);
  };
  const handleClickMenuProfile = async (typeMenu: any) => {
    if (checkCreatedOrder && (typeMenu === KEY_MENU.logout || typeMenu === KEY_MENU.change_subscription)) {
      setVisibleModalAlertWarrning(true);
      setKeyMenu(typeMenu);
      return;
    }
    if (typeMenu === KEY_MENU.logout) {
      handleLogout();
    }
    if (typeMenu === KEY_MENU.change_subscription) {
      if (profile?.accountType === CustomerAccountType.BUSINESS) {
        //TODO: 言語設定より弄れるようにする
        if(window.confirm('サブスクリプションを解約しますか？')) {
          try {
            await cancelSubscription()
            // message.success(t('success.paymentSuccess'));
            window.alert('サブスクリプションを解約しました')
            history.go(0)
          } catch (e) {
            handleErrorMessage(e)
          }
        }
        return;
      }
    }
    const navPush = {
      [KEY_MENU.personal_information]: '/my-page/personal-information',
      [KEY_MENU.delivery_address_book]: '/my-page/delivery-address-book',
      [KEY_MENU.email_address_book]: '/my-page/email-address-book',
      [KEY_MENU.change_password]: '/my-page/change-password',
      [KEY_MENU.privacy_policy]: '/my-page-privacy-policy',
      [KEY_MENU.change_subscription]: '/my-page/change-account'
    } as any;
    if (checkCreatedOrder && navPush[typeMenu]) {
      setVisibleModalAlertWarrning(true);
      setUrl(navPush[typeMenu]);
      return;
    }
    history.push(navPush[typeMenu]);
  };
  const menu = (
    <Menu style={{ minWidth: 200 }} onClick={handleClickMenuProfile}>
      <Menu.Item key="1" onClick={() => handleClickMenuProfile(KEY_MENU.personal_information)}>
        {t('common.profile')}
      </Menu.Item>
      <Menu.Item key="2" onClick={() => handleClickMenuProfile(KEY_MENU.delivery_address_book)}>
        {t('sideNav.deliveryAddressBook')}
      </Menu.Item>
      <Menu.Item key="3" onClick={() => handleClickMenuProfile(KEY_MENU.email_address_book)}>
        {t('sideNav.emailAddress')}
      </Menu.Item>
      <Menu.Item key="4" onClick={() => handleClickMenuProfile(KEY_MENU.change_password)}>
        {t('common.changePassword')}
      </Menu.Item>
      {profile?.accountType === CustomerAccountType.PERSONAL ? (
        <Menu.Item key="5" onClick={() => handleClickMenuProfile(KEY_MENU.change_subscription)}>
          {t('sideNav.registerSubscription')}
        </Menu.Item>
      ): (
        ''
      )}
      {profile?.accountType === CustomerAccountType.BUSINESS ? (
        <Menu.Item key="5" onClick={() => handleClickMenuProfile(KEY_MENU.change_subscription)}>
          {t('sideNav.cancelSubscription')}
        </Menu.Item>
      ): (
        ''
      )}
      <Menu.Item key="6" onClick={() => handleClickMenuProfile(KEY_MENU.privacy_policy)}>
        {t('sideNav.privacyPolicySideNav')}
      </Menu.Item>
      <Menu.Item key="7" onClick={() => handleClickMenuProfile(KEY_MENU.logout)}>
        {t('common.logout')}
      </Menu.Item>
    </Menu>
  );
  const menuLanguage = (
    <Menu style={{ minWidth: 200 }}>
      <Menu.Item key="1" onClick={() => changeLanguage('en')}>
        {t('language.en')}
      </Menu.Item>
      <Menu.Item key="2" onClick={() => changeLanguage('ja')}>
        {t('language.ja')}
      </Menu.Item>
      {configs?.APP_ENV === 'dev' ? (
        <Menu.Item key="3" onClick={() => changeLanguage('cimode')}>
          SHOW KEY
        </Menu.Item>
      ) : (
        ''
      )}
    </Menu>
  );

  const handleOpen = (value: any) => {
    setIsOpenMenuMobile(value);
  };

  const handleOnClickLogo = () => {
    if (checkCreatedOrder) {
      setVisibleModalAlertWarrning(true);
      setUrl('/dashboard');
      return;
    }
    history.push('/dashboard');
  };
  const handleOkModalAlert = () => {
    if (keyMenu === KEY_MENU.logout) {
      handleLogout();
      return;
    }
    setVisibleModalAlertWarrning(false);
    history.push(url);
  };
  const handleClickSub = () => {
    if (checkCreatedOrder) {
      setVisibleModalAlertWarrning(true);
      setUrl('/subcribe/register-subcribe');
      return;
    }
    history.push('/subcribe/register-subcribe');
  };
  return (
    <div className={styles.headerWrapper}>
      {isMobile && (
        <div className={styles.hamburgerWrapper}>
          <Hamburger toggled={isOpenMenuMobile} toggle={(value: any) => handleOpen(value)} color={'#fff'} />
        </div>
      )}

      <Link className={styles.logo} to="#" onClick={handleOnClickLogo}>
        <img src={i18n.language === LANGUAGE.JA ? logo : logoForeign} />
      </Link>
      {!isMobile && (
        <div className={styles.menuWrapper}>
          {profile?.accountType == CustomerAccountType.BUSINESS && profile?.isFreeSubscription === ACTIVE.FALSE && (
            <div className={styles.menuItem} onClick={handleClickSub}>
              <div className={styles.subcribe}>
                <img src={iconUsd} alt="" />
                <div className={styles.contentSub}>
                  <p className="fontWeightBold margin-bottom-0">{t('common.subcribe')}</p>
                  <p className="margin-bottom-0">{t('common.free2weeks')}</p>
                </div>
              </div>
            </div>
          )}
          {/* <div className={styles.menuItem}>
            <Dropdown overlay={menuLanguage} trigger={['click']}>
              <div>
                <img className={styles.icon} src={i18n?.language === LANGUAGE.JA ? iconJapan : flagEnglish} />
                <span>{t(`language.${i18n?.language}`)}</span>
                <img src={turnDown} />
                &nbsp;
              </div>
            </Dropdown>
          </div> */}
          <div className={styles.menuItem}>
            <Dropdown overlay={menu} trigger={['click']}>
              <div>
                <img className={styles.icon} src={profile?.avatar || avatarDefault} alt="" />
                <span>{`${getFullNameByLocation(profile)}`}</span>
                <img src={turnDown} alt="" />
                &nbsp;
              </div>
            </Dropdown>
          </div>
        </div>
      )}
      <ModalAlert
        visible={!!visibleModalAlertWarring}
        onOk={handleOkModalAlert}
        onCancel={() => setVisibleModalAlertWarrning(false)}
      />
    </div>
  );
}
